// extracted by mini-css-extract-plugin
export var cell = "_4w-4";
export var headerCell = "_4w-2";
export var rowHeader = "_4w-3";
export var table = "_4w-1";
export var tableContainer = "_4w-0";